import { Helmet } from 'react-helmet-async';
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { ProductConfigurationContent } from './components/ProductConfigurationContent';
import { ConfigurationPanelContextProvider } from './components/ProductConfigurationBulkUpdate/ConfigurationPanelContext';
import { Permission } from '@/models/user';
import { PageWithLayout } from '@/models/page';

const ProductConfiguration: PageWithLayout = () => {
    return (
        <ConfigurationPanelContextProvider>
            <Helmet>
                <title>Produktkonfiguration | Starjack Admin</title>
            </Helmet>

            <ProductConfigurationContent />
        </ConfigurationPanelContextProvider>
    );
};

ProductConfiguration.isProtected = true;
ProductConfiguration.getLayout = (page) => (
    <SidebarLayout>{page}</SidebarLayout>
);
ProductConfiguration.permissions = [Permission.LIFTOPERATOR_CONFIGURATION_NAV];

export default ProductConfiguration;
